webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _preact = __webpack_require__(1);
	
	var _legeViewer = __webpack_require__(9);
	
	var _legeViewer2 = _interopRequireDefault(_legeViewer);
	
	var _relatedStories = __webpack_require__(23);
	
	var _relatedStories2 = _interopRequireDefault(_relatedStories);
	
	var _adLoader = __webpack_require__(26);
	
	var _adLoader2 = _interopRequireDefault(_adLoader);
	
	__webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var viewerContainer = document.getElementById('stream-viewer-container');
	
	(0, _preact.render)((0, _preact.h)(_legeViewer2.default, null), viewerContainer, viewerContainer.lastElementChild);
	
	/**
	 * This is the loader managing the primary related content feed. It uses the
	 * `subject-85th-legislative-session` Guten tag.
	 */
	(0, _preact.render)((0, _preact.h)(_relatedStories2.default, { src: 'https://www.texastribune.org/api/v1/content/?content_type=story,audio,video,pointer&tag=subject-85th-legislative-session&fields=id,url,readable_pub_date,seo_headline,short_summary,lead_art&limit=8&format=json' }), document.getElementById('related-stories-grid'));
	
	/**
	 * These renderers are what power the other related content sections. If any
	 * changes are going to be made, they are most likely going to happen here.
	 *
	 * Each one gets entered in the element passed at the end of the renderer. If
	 * you have to add more, there are others to uncomment below. Make sure they
	 * also have an HTML element to load into!
	 */
	(0, _preact.render)((0, _preact.h)(_relatedStories2.default, { isColumn: true, title: 'Bathroom bill', tag: 'subject-bathroom-bill' }), document.getElementById('top-topics-grid-1'));
	
	(0, _preact.render)((0, _preact.h)(_relatedStories2.default, {
	  isColumn: true,
	  title: 'Public education',
	  tag: 'subject-public-education'
	}), document.getElementById('top-topics-grid-2'));
	
	// A template for any new ones.
	//
	// render(
	//   <RelatedStories
	//     isColumn
	//     title=""
	//     tag=""
	//   />,
	//   document.getElementById('top-topics-grid-3')
	// );
	
	/**
	 * This handles the loading of the ads on the page.
	 * @type {Object}
	 */
	var adLoader = (0, _adLoader2.default)({
	  targetingValue: '85th-lege'
	});
	adLoader.init();

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var assign = __webpack_require__(3);
	var getAttributes = __webpack_require__(48);
	
	
	var utilities = {
	
	
	  /**
	   * Accepts default and user override fields and an optional tracker, hit
	   * filter, and target element and returns a single object that can be used in
	   * `ga('send', ...)` commands.
	   * @param {Object} defaultFields The default fields to return.
	   * @param {Object} userFields Fields set by the user to override the defaults.
	   * @param {Object} opt_tracker The tracker object to apply the hit filter to.
	   * @param {Function} opt_hitFilter A filter function that gets
	   *     called with the tracker model right before the `buildHitTask`. It can
	   *     be used to modify the model for the current hit only.
	   * @param {Element} opt_target If the hit originated from an interaction
	   *     with a DOM element, hitFilter is invoked with that element as the
	   *     second argument.
	   * @return {Object} The final fields object.
	   */
	  createFieldsObj: function(
	      defaultFields, userFields, opt_tracker, opt_hitFilter, opt_target) {
	
	    if (typeof opt_hitFilter == 'function') {
	      var originalBuildHitTask = opt_tracker.get('buildHitTask');
	      return {
	        buildHitTask: function(model) {
	          model.set(defaultFields, null, true);
	          model.set(userFields, null, true);
	          opt_hitFilter(model, opt_target);
	          originalBuildHitTask(model);
	        }
	      };
	    }
	    else {
	      return assign({}, defaultFields, userFields);
	    }
	  },
	
	
	  /**
	   * Retrieves the attributes from an DOM element and returns a fields object
	   * for all attributes matching the passed prefix string.
	   * @param {Element} element The DOM element to get attributes from.
	   * @param {string} prefix An attribute prefix. Only the attributes matching
	   *     the prefix will be returned on the fields object.
	   * @return {Object} An object of analytics.js fields and values
	   */
	  getAttributeFields: function(element, prefix) {
	    var attributes = getAttributes(element);
	    var attributeFields = {};
	
	    Object.keys(attributes).forEach(function(attribute) {
	
	      // The `on` prefix is used for event handling but isn't a field.
	      if (attribute.indexOf(prefix) === 0 && attribute != prefix + 'on') {
	
	        var value = attributes[attribute];
	
	        // Detects Boolean value strings.
	        if (value == 'true') value = true;
	        if (value == 'false') value = false;
	
	        var field = utilities.camelCase(attribute.slice(prefix.length));
	        attributeFields[field] = value;
	      }
	    });
	
	    return attributeFields;
	  },
	
	
	  domReady: function(callback) {
	    if (document.readyState == 'loading') {
	      document.addEventListener('DOMContentLoaded', function fn() {
	        document.removeEventListener('DOMContentLoaded', fn);
	        callback();
	      });
	    } else {
	      callback();
	    }
	  },
	
	
	  /**
	   * Accepts a function and returns a wrapped version of the function that is
	   * expected to be called elsewhere in the system. If it's not called
	   * elsewhere after the timeout period, it's called regardless. The wrapper
	   * function also prevents the callback from being called more than once.
	   * @param {Function} callback The function to call.
	   * @param {number} wait How many milliseconds to wait before invoking
	   *     the callback.
	   * @returns {Function} The wrapped version of the passed function.
	   */
	  withTimeout: function(callback, wait) {
	    var called = false;
	    var fn = function() {
	      if (!called) {
	        called = true;
	        callback();
	      }
	    };
	    setTimeout(fn, wait || 2000);
	    return fn;
	  },
	
	
	  /**
	   * Accepts a string containing hyphen or underscore word separators and
	   * converts it to camelCase.
	   * @param {string} str The string to camelCase.
	   * @return {string} The camelCased version of the string.
	   */
	  camelCase: function(str) {
	    return str.replace(/[\-\_]+(\w?)/g, function(match, p1) {
	      return p1.toUpperCase();
	    });
	  },
	
	
	  /**
	   * Capitalizes the first letter of a string.
	   * @param {string} str The input string.
	   * @return {string} The capitalized string
	   */
	  capitalize: function(str) {
	    return str.charAt(0).toUpperCase() + str.slice(1);
	  },
	
	
	  /**
	   * Indicates whether the passed variable is a JavaScript object.
	   * @param {*} value The input variable to test.
	   * @return {boolean} Whether or not the test is an object.
	   */
	  isObject: function(value) {
	    return typeof value == 'object' && value !== null;
	  },
	
	
	  /**
	   * Indicates whether the passed variable is a JavaScript array.
	   * @param {*} value The input variable to test.
	   * @return {boolean} Whether or not the value is an array.
	   */
	  isArray: Array.isArray || function(value) {
	    return Object.prototype.toString.call(value) === '[object Array]';
	  },
	
	
	  /**
	   * Accepts a value that may or may not be an array. If it is not an array,
	   * it is returned as the first item in a single-item array.
	   * @param {*} value The value to convert to an array if it is not.
	   * @return {Array} The array-ified value.
	   */
	  toArray: function(value) {
	    return utilities.isArray(value) ? value : [value];
	  }
	};
	
	module.exports = utilities;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var constants = __webpack_require__(7);
	var utilities = __webpack_require__(2);
	
	
	// Adds the dev ID to the list of dev IDs if any plugin is used.
	(window.gaDevIds = window.gaDevIds || []).push(constants.DEV_ID);
	
	
	/**
	 * Provides a plugin for use with analytics.js, accounting for the possibility
	 * that the global command queue has been renamed or not yet defined.
	 * @param {string} pluginName The plugin name identifier.
	 * @param {Function} pluginConstructor The plugin constructor function.
	 */
	module.exports = function providePlugin(pluginName, pluginConstructor) {
	  var gaAlias = window['GoogleAnalyticsObject'] || 'ga';
	  window[gaAlias] = window[gaAlias] || function() {
	    (window[gaAlias]['q'] = window[gaAlias]['q'] || []).push(arguments);
	  };
	
	  // Formally provides the plugin for use with analytics.js.
	  window[gaAlias]('provide', pluginName, pluginConstructor);
	
	  // Registers the plugin on the global gaplugins object.
	  window.gaplugins = window.gaplugins || {};
	  window.gaplugins[utilities.capitalize(pluginName)] = pluginConstructor;
	};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var constants = __webpack_require__(7);
	
	
	var plugins = {
	  CLEAN_URL_TRACKER: 1,
	  EVENT_TRACKER: 2,
	  IMPRESSION_TRACKER: 3,
	  MEDIA_QUERY_TRACKER: 4,
	  OUTBOUND_FORM_TRACKER: 5,
	  OUTBOUND_LINK_TRACKER: 6,
	  PAGE_VISIBILITY_TRACKER: 7,
	  SOCIAL_WIDGET_TRACKER: 8,
	  URL_CHANGE_TRACKER: 9
	};
	var PLUGIN_COUNT = 9;
	
	
	/**
	 * Converts a hexadecimal string to a binary string.
	 * @param {string} hex A hexadecimal numeric string.
	 * @return {string} a binary numeric string.
	 */
	function convertHexToBin(hex) {
	  return parseInt(hex || '0', 16).toString(2);
	}
	
	
	/**
	 * Converts a binary string to a hexadecimal string.
	 * @param {string} bin A binary numeric string.
	 * @return {string} a hexadecimal numeric string.
	 */
	function convertBinToHex(bin) {
	  return parseInt(bin || '0', 2).toString(16);
	}
	
	
	/**
	 * Adds leading zeros to a string if it's less than a minimum length.
	 * @param {string} str A string to pad.
	 * @param {number} len The minimum length of the string
	 * @return {string} The padded string.
	 */
	function padZeros(str, len) {
	  if (str.length < len) {
	    var toAdd = len - str.length;
	    while (toAdd) {
	      str = '0' + str;
	      toAdd--;
	    }
	  }
	  return str;
	}
	
	
	/**
	 * Accepts a binary numeric string and flips the digit from 0 to 1 at the
	 * specified index.
	 * @param {string} str The binary numeric string.
	 * @param {number} index The index to flip the bit.
	 * @return {string} The new binary string with the bit flipped on
	 */
	function flipBitOn(str, index) {
	  return str.substr(0, index) + 1 + str.substr(index + 1);
	}
	
	
	/**
	 * Accepts a tracker and a plugin index and flips the bit at the specified
	 * index on the tracker's usage parameter.
	 * @param {Object} tracker An analytics.js tracker.
	 * @param {number} pluginIndex The index of the plugin in the global list.
	 */
	function trackPlugin(tracker, pluginIndex) {
	  var usageHex = tracker.get(constants.USAGE_PARAM);
	  var usageBin = padZeros(convertHexToBin(usageHex), PLUGIN_COUNT);
	
	  // Flip the bit of the plugin being tracked.
	  usageBin = flipBitOn(usageBin, PLUGIN_COUNT - pluginIndex);
	
	  // Stores the modified usage string back on the tracker.
	  tracker.set(constants.USAGE_PARAM, convertBinToHex(usageBin));
	}
	
	
	/**
	 * Accepts a tracker and adds the current version to the version param.
	 * @param {Object} tracker An analytics.js tracker.
	 */
	function trackVersion(tracker) {
	  tracker.set(constants.VERSION_PARAM, constants.VERSION);
	}
	
	
	module.exports = {
	  track: function(tracker, plugin) {
	    trackVersion(tracker);
	    trackPlugin(tracker, plugin);
	  },
	  plugins: plugins
	};


/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	module.exports = {
	  VERSION: '1.0.0',
	  DEV_ID: 'i5iSjo',
	
	  VERSION_PARAM: '&_av',
	  USAGE_PARAM: '&_au',
	
	  NULL_DIMENSION: '(not set)'
	};


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var closest = __webpack_require__(47);
	var matches = __webpack_require__(14);
	
	/**
	 * Delegates the handling of events for an element matching a selector to an
	 * ancestor of the matching element.
	 * @param {Element} ancestor The ancestor element to add the listener to.
	 * @param {string} eventType The event type to listen to.
	 * @param {string} selector A CSS selector to match against child elements.
	 * @param {Function} callback A function to run any time the event happens.
	 * @param {Object} opts A configuration options object. The available options:
	 *     - useCapture<boolean>: If true, bind to the event capture phase.
	 *     - deep<boolean>: If true, delegate into shadow trees.
	 * @return {Object} The delegate object. It contains a destroy method.
	 */
	 module.exports = function delegate(
	    ancestor, eventType, selector, callback, opts) {
	
	  opts = opts || {};
	
	  // Defines the event listener.
	  var listener = function(event) {
	
	    // If opts.composed is true and the event originated from inside a Shadow
	    // tree, check the composed path nodes.
	    if (opts.composed && typeof event.composedPath == 'function') {
	      var composedPath = event.composedPath();
	      for (var i = 0, node; node = composedPath[i]; i++) {
	        if (node.nodeType == 1 && matches(node, selector)) {
	          delegateTarget = node;
	        }
	      }
	    }
	    // Otherwise check the parents.
	    else {
	      var delegateTarget = closest(event.target, selector, true);
	    }
	
	    if (delegateTarget) {
	      callback.call(delegateTarget, event, delegateTarget);
	    }
	  };
	
	  ancestor.addEventListener(eventType, listener, opts.useCapture);
	
	  return {
	    destroy: function() {
	      ancestor.removeEventListener(eventType, listener, opts.useCapture);
	    }
	  };
	};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	var proto = window.Element.prototype;
	var nativeMatches = proto.matches ||
	    proto.matchesSelector ||
	    proto.webkitMatchesSelector ||
	    proto.mozMatchesSelector ||
	    proto.msMatchesSelector ||
	    proto.oMatchesSelector;
	
	
	/**
	 * Tests whether a DOM element matches a selector. This polyfills the native
	 * Element.prototype.matches method across browsers.
	 * @param {Element} element The DOM element to test.
	 * @param {string} selector The CSS selector to test element against.
	 * @return {boolean} True if the selector matches.
	 */
	 function matchesSelector(element, selector) {
	  if (typeof selector != 'string') return false;
	  if (nativeMatches) return nativeMatches.call(element, selector);
	  var nodes = element.parentNode.querySelectorAll(selector);
	  for (var i = 0, node; node = nodes[i]; i++) {
	    if (node == element) return true;
	  }
	  return false;
	}
	
	
	/**
	 * Tests if a DOM elements matches any of the test DOM elements or selectors.
	 * @param {Element} element The DOM element to test.
	 * @param {Element|string|Array<Element|String>} test A DOM element, a CSS
	 *     selector, or an array of DOM elements or CSS selectors to match against.
	 * @return {boolean} True of any part of the test matches.
	 */
	module.exports = function matches(element, test) {
	  // Validate input.
	  if (element && element.nodeType == 1 && test) {
	    // if test is a string or DOM element test it.
	    if (typeof test == 'string' || test.nodeType == 1) {
	      return element == test || matchesSelector(element, test);
	    }
	    // if it has a length property iterate over the items
	    // and return true if any match.
	    else if ('length' in test) {
	      for (var i = 0, item; item = test[i]; i++) {
	        if (element == item || matchesSelector(element, item)) return true;
	      }
	    }
	  }
	  // Still here? Return false
	  return false;
	};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	var HTTP_PORT = '80';
	var HTTPS_PORT = '443';
	var DEFAULT_PORT = RegExp(':(' + HTTP_PORT + '|' + HTTPS_PORT + ')$');
	
	
	var a = document.createElement('a');
	var cache = {};
	
	
	/**
	 * Parses the given url and returns an object mimicing a `Location` object.
	 * @param {string} url The url to parse.
	 * @return {Object} An object with the same properties as a `Location`
	 *    plus the convience properties `path` and `query`.
	 */
	module.exports = function parseUrl(url) {
	
	  // All falsy values (as well as ".") should map to the current URL.
	  url = (!url || url == '.') ? location.href : url;
	
	  if (cache[url]) return cache[url];
	
	  a.href = url;
	
	  // When parsing file relative paths (e.g. `../index.html`), IE will correctly
	  // resolve the `href` property but will keep the `..` in the `path` property.
	  // It will also not include the `host` or `hostname` properties. Furthermore,
	  // IE will sometimes return no protocol or just a colon, especially for things
	  // like relative protocol URLs (e.g. "//google.com").
	  // To workaround all of these issues, we reparse with the full URL from the
	  // `href` property.
	  if (url.charAt(0) == '.' || url.charAt(0) == '/') return parseUrl(a.href);
	
	  // Don't include default ports.
	  var port = (a.port == HTTP_PORT || a.port == HTTPS_PORT) ? '' : a.port;
	
	  // PhantomJS sets the port to "0" when using the file: protocol.
	  port = port == '0' ? '' : port;
	
	  // Sometimes IE incorrectly includes a port for default ports
	  // (e.g. `:80` or `:443`) even when no port is specified in the URL.
	  // http://bit.ly/1rQNoMg
	  var host = a.host.replace(DEFAULT_PORT, '');
	
	  // Not all browser support `origin` so we have to build it.
	  var origin = a.origin ? a.origin : a.protocol + '//' + host;
	
	  // Sometimes IE doesn't include the leading slash for pathname.
	  // http://bit.ly/1rQNoMg
	  var pathname = a.pathname.charAt(0) == '/' ? a.pathname : '/' + a.pathname;
	
	  return cache[url] = {
	    hash: a.hash,
	    host: host,
	    hostname: a.hostname,
	    href: a.href,
	    origin: origin,
	    pathname: pathname,
	    port: port,
	    protocol: a.protocol,
	    search: a.search,
	
	    // Expose additional helpful properties not part of the Location object.
	    fragment: a.hash.slice(1), // The hash without the starting "#".
	    path: pathname + a.search, // The pathname and the search query (w/o hash).
	    query: a.search.slice(1) // The search without the starting "?".
	  };
	};


/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var assign = __webpack_require__(3);
	var parseUrl = __webpack_require__(15);
	var constants = __webpack_require__(7);
	var provide = __webpack_require__(4);
	var usage = __webpack_require__(5);
	
	
	/**
	 * Registers clean URL tracking on a tracker object. The clean URL tracker
	 * removes query parameters from the page value reported to Google Analytics.
	 * It also helps to prevent tracking similar URLs, e.g. sometimes ending a URL
	 * with a slash and sometimes not.
	 * @constructor
	 * @param {Object} tracker Passed internally by analytics.js
	 * @param {?Object} opts Passed by the require command.
	 */
	function CleanUrlTracker(tracker, opts) {
	
	  usage.track(tracker, usage.plugins.CLEAN_URL_TRACKER);
	
	  this.opts = assign({
	    stripQuery: false,
	    queryDimensionIndex: null,
	    indexFilename: null,
	    trailingSlash: null
	  }, opts);
	
	  this.tracker = tracker;
	
	  this.overrideTrackerBuildHitTask();
	}
	
	
	/**
	 * Cleans the URL based on the preferences set in the configuration options.
	 * @param {Object} model An analytics.js Model object.
	 */
	CleanUrlTracker.prototype.cleanUrlTask = function(model) {
	
	  var location = model.get('location');
	  var page = model.get('page');
	  var url = parseUrl(page || location);
	
	  var oldPath = url.pathname;
	  var newPath = oldPath;
	
	  // If an index filename was provided, remove it if it appears at the end
	  // of the URL.
	  if (this.opts.indexFilename) {
	    var parts = newPath.split('/');
	    if (this.opts.indexFilename == parts[parts.length - 1]) {
	      parts[parts.length - 1] = '';
	      newPath = parts.join('/');
	    }
	  }
	
	  // Ensure the URL ends with or doesn't end with slash based on the
	  // `trailingSlash` option. Note that filename URLs should never contain
	  // a trailing slash.
	  if (this.opts.trailingSlash == 'remove') {
	      newPath = newPath.replace(/\/+$/, '');
	  }
	  else if (this.opts.trailingSlash == 'add') {
	    var isFilename = /\.\w+$/.test(newPath);
	    if (!isFilename && newPath.substr(-1) != '/') {
	      newPath = newPath + '/';
	    }
	  }
	
	  // If a query dimensions index was provided, set the query string portion
	  // of the URL on that dimension. If no query string exists on the URL use
	  // the NULL_DIMENSION.
	  if (this.opts.stripQuery && this.opts.queryDimensionIndex) {
	    model.set('dimension' + this.opts.queryDimensionIndex,
	        url.query || constants.NULL_DIMENSION);
	  }
	
	  model.set('page', newPath + (!this.opts.stripQuery ? url.search : ''));
	};
	
	
	/**
	 * Overrides the tracker's `buildHitTask` to check for proper URL formatting
	 * on every hit (not just the initial pageview).
	 */
	CleanUrlTracker.prototype.overrideTrackerBuildHitTask = function() {
	  this.originalTrackerBuildHitTask = this.tracker.get('buildHitTask');
	
	  this.tracker.set('buildHitTask', function(model) {
	    this.cleanUrlTask(model);
	    this.originalTrackerBuildHitTask(model);
	  }.bind(this));
	};
	
	
	/**
	 * Restores all overridden tasks and methods.
	 */
	CleanUrlTracker.prototype.remove = function() {
	  this.tracker.set('sendHitTask', this.originalTrackerSendHitTask);
	};
	
	
	provide('cleanUrlTracker', CleanUrlTracker);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var assign = __webpack_require__(3);
	var delegate = __webpack_require__(13);
	var provide = __webpack_require__(4);
	var usage = __webpack_require__(5);
	var createFieldsObj = __webpack_require__(2).createFieldsObj;
	var getAttributeFields = __webpack_require__(2).getAttributeFields;
	
	
	/**
	 * Registers declarative event tracking.
	 * @constructor
	 * @param {Object} tracker Passed internally by analytics.js
	 * @param {?Object} opts Passed by the require command.
	 */
	function EventTracker(tracker, opts) {
	
	  usage.track(tracker, usage.plugins.EVENT_TRACKER);
	
	  // Feature detects to prevent errors in unsupporting browsers.
	  if (!window.addEventListener) return;
	
	  this.opts = assign({
	    events: ['click'],
	    fieldsObj: {},
	    attributePrefix: 'ga-',
	    hitFilter: null
	  }, opts);
	
	  this.tracker = tracker;
	
	  // Binds methods.
	  this.handleEvents = this.handleEvents.bind(this);
	
	  var selector = '[' + this.opts.attributePrefix + 'on]';
	
	  // Creates a mapping of events to their delegates
	  this.delegates = {};
	  this.opts.events.forEach(function(event) {
	    this.delegates[event] = delegate(document, event, selector,
	        this.handleEvents, {composed: true, useCapture: true});
	  }.bind(this));
	}
	
	
	/**
	 * Handles all clicks on elements with event attributes.
	 * @param {Event} event The DOM click event.
	 * @param {Element} element The delegated DOM element target.
	 */
	EventTracker.prototype.handleEvents = function(event, element) {
	
	  var prefix = this.opts.attributePrefix;
	
	  // Ensures the event type matches the one specified on the element.
	  if (event.type != element.getAttribute(prefix + 'on')) return;
	
	  var defaultFields = {transport: 'beacon'};
	  var attributeFields = getAttributeFields(element, prefix);
	  var userFields = assign({}, this.opts.fieldsObj, attributeFields);
	  var hitType = attributeFields.hitType || 'event';
	
	  this.tracker.send(hitType, createFieldsObj(
	      defaultFields, userFields, this.tracker, this.opts.hitFilter, element));
	};
	
	
	/**
	 * Removes all event listeners and instance properties.
	 */
	EventTracker.prototype.remove = function() {
	  Object.keys(this.delegates).forEach(function(key) {
	    this.delegates[key].destroy();
	  }.bind(this));
	};
	
	
	provide('eventTracker', EventTracker);


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var assign = __webpack_require__(3);
	var delegate = __webpack_require__(13);
	var parseUrl = __webpack_require__(15);
	var provide = __webpack_require__(4);
	var usage = __webpack_require__(5);
	var createFieldsObj = __webpack_require__(2).createFieldsObj;
	var getAttributeFields = __webpack_require__(2).getAttributeFields;
	
	
	/**
	 * Registers outbound link tracking on a tracker object.
	 * @constructor
	 * @param {Object} tracker Passed internally by analytics.js
	 * @param {?Object} opts Passed by the require command.
	 */
	function OutboundLinkTracker(tracker, opts) {
	
	  usage.track(tracker, usage.plugins.OUTBOUND_LINK_TRACKER);
	
	  // Feature detects to prevent errors in unsupporting browsers.
	  if (!window.addEventListener) return;
	
	  this.opts = assign({
	    events: ['click'],
	    linkSelector: 'a, area',
	    shouldTrackOutboundLink: this.shouldTrackOutboundLink,
	    fieldsObj: {},
	    attributePrefix: 'ga-',
	    hitFilter: null
	  }, opts);
	
	  this.tracker = tracker;
	
	  // Binds methods.
	  this.handleLinkInteractions = this.handleLinkInteractions.bind(this);
	
	  // Creates a mapping of events to their delegates
	  this.delegates = {};
	  this.opts.events.forEach(function(event) {
	    this.delegates[event] = delegate(document, event, this.opts.linkSelector,
	        this.handleLinkInteractions, {composed: true, useCapture: true});
	  }.bind(this));
	}
	
	
	/**
	 * Handles all interactions on link elements. A link is considered an outbound
	 * link if its hostname property does not match location.hostname. When the
	 * beacon transport method is not available, the links target is set to
	 * "_blank" to ensure the hit can be sent.
	 * @param {Event} event The DOM click event.
	 * @param {Element} link The delegated event target.
	 */
	OutboundLinkTracker.prototype.handleLinkInteractions = function(event, link) {
	
	  if (this.opts.shouldTrackOutboundLink(link, parseUrl)) {
	    // Opens outbound links in a new tab if the browser doesn't support
	    // the beacon transport method.
	    if (!navigator.sendBeacon) {
	      link.target = '_blank';
	    }
	
	    var href = link.getAttribute('href') || link.getAttribute('xlink:href');
	    var url = parseUrl(href);
	
	    var defaultFields = {
	      transport: 'beacon',
	      eventCategory: 'Outbound Link',
	      eventAction: event.type,
	      eventLabel: url.href
	    };
	
	    var userFields = assign({}, this.opts.fieldsObj,
	        getAttributeFields(link, this.opts.attributePrefix));
	
	    this.tracker.send('event', createFieldsObj(
	        defaultFields, userFields, this.tracker, this.opts.hitFilter, link));
	  }
	};
	
	
	/**
	 * Determines whether or not the tracker should send a hit when a link is
	 * clicked. By default links with a hostname property not equal to the current
	 * hostname are tracked.
	 * @param {Element} link The link that was clicked on.
	 * @param {Function} parseUrl A cross-browser utility method for url parsing.
	 * @return {boolean} Whether or not the link should be tracked.
	 */
	OutboundLinkTracker.prototype.shouldTrackOutboundLink =
	    function(link, parseUrl) {
	
	  var href = link.getAttribute('href') || link.getAttribute('xlink:href');
	  var url = parseUrl(href);
	  return url.hostname != location.hostname &&
	      url.protocol.slice(0, 4) == 'http';
	};
	
	
	/**
	 * Removes all event listeners and instance properties.
	 */
	OutboundLinkTracker.prototype.remove = function() {
	  Object.keys(this.delegates).forEach(function(key) {
	    this.delegates[key].destroy();
	  }.bind(this));
	};
	
	
	provide('outboundLinkTracker', OutboundLinkTracker);


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	var assign = __webpack_require__(3);
	var provide = __webpack_require__(4);
	var usage = __webpack_require__(5);
	var createFieldsObj = __webpack_require__(2).createFieldsObj;
	var isObject = __webpack_require__(2).isObject;
	
	
	var DEFAULT_SESSION_TIMEOUT = 30; // 30 minutes.
	
	
	/**
	 * Registers outbound link tracking on tracker object.
	 * @constructor
	 * @param {Object} tracker Passed internally by analytics.js
	 * @param {?Object} opts Passed by the require command.
	 */
	function PageVisibilityTracker(tracker, opts) {
	
	  usage.track(tracker, usage.plugins.PAGE_VISIBILITY_TRACKER);
	
	  // Feature detects to prevent errors in unsupporting browsers.
	  if (!window.addEventListener) return;
	
	  this.opts = assign({
	    sessionTimeout: DEFAULT_SESSION_TIMEOUT,
	    changeTemplate: this.changeTemplate,
	    hiddenMetricIndex: null,
	    visibleMetricIndex: null,
	    fieldsObj: {},
	    hitFilter: null
	  }, opts);
	
	  this.tracker = tracker;
	  this.visibilityState = document.visibilityState;
	
	  // Consider the plugin creation to be the start of the visibility change
	  // time calculations.
	  this.lastVisibilityChangeTime = +new Date;
	
	  // Binds methods to `this`.
	  this.handleVisibilityStateChange =
	      this.handleVisibilityStateChange.bind(this);
	
	  this.overrideTrackerSendMethod();
	  this.overrideTrackerSendHitTask();
	
	  document.addEventListener(
	      'visibilitychange', this.handleVisibilityStateChange);
	}
	
	
	/**
	 * Handles changes to `document.visibilityState`. This method sends events when
	 * the visibility state changes during active sessions (active meaning the
	 * session has not timed out). If the session has timed out, a return to a
	 * visibility state of visible will trigger a new pageview (instead of a
	 * visibility change event). Lastly, this method keeps track of the elapsed
	 * time a document's visibility state was visible and sends that as the event
	 * value for hidden events, allowing you to more accurately derive how long
	 * a user spent active during a session.
	 */
	PageVisibilityTracker.prototype.handleVisibilityStateChange = function() {
	
	  var defaultFields;
	  this.prevVisibilityState = this.visibilityState;
	  this.visibilityState = document.visibilityState;
	
	  if (this.sessionHasTimedOut()) {
	    // Prevents sending 'hidden' state hits when the session has timed out.
	    if (this.visibilityState == 'hidden') return;
	
	    if (this.visibilityState == 'visible') {
	      // If the session has timed out, a transition to "visible" should be
	      // considered a new pageview and a new session.
	      defaultFields = {transport: 'beacon'};
	      this.tracker.send('pageview', createFieldsObj(defaultFields,
	          this.opts.fieldsObj, this.tracker, this.opts.hitFilter));
	    }
	  }
	  else {
	    // Rounds the time up to the nearest second. If the rounded value is zero
	    // use 1 instead since unset metrics default to 0.
	    var timeDeltaInSeconds = Math.round(
	        (new Date - this.lastVisibilityChangeTime) / 1000) || 1;
	
	    defaultFields = {
	      transport: 'beacon',
	      eventCategory: 'Page Visibility',
	      eventAction: 'change',
	      eventLabel: this.opts.changeTemplate(
	          this.prevVisibilityState, this.visibilityState),
	      eventValue: timeDeltaInSeconds
	    };
	
	    // Changes to hidden are non interaction hits by default
	    if (this.visibilityState == 'hidden') defaultFields.nonInteraction = true;
	
	    // If a custom metric was specified for the current visibility state,
	    // give it the same as the event value.
	    var metric = this.opts[this.prevVisibilityState + 'MetricIndex'];
	    if (metric) defaultFields['metric' + metric] = timeDeltaInSeconds;
	
	    this.tracker.send('event', createFieldsObj(defaultFields,
	        this.opts.fieldsObj, this.tracker, this.opts.hitFilter));
	  }
	
	  // Updates the time the last visibility state change event occurred, so
	  // change events can report the delta.
	  this.lastVisibilityChangeTime = +new Date;
	};
	
	
	/**
	 * Returns true if the session has not timed out. A session timeout occurs when
	 * more than `this.opts.sessionTimeout` minutes has elapsed since the
	 * tracker sent the previous hit.
	 * @return {boolean} True if the session has timed out.
	 */
	PageVisibilityTracker.prototype.sessionHasTimedOut = function() {
	  var minutesSinceLastHit = (new Date - this.lastHitTime) / (60 * 1000);
	  return this.opts.sessionTimeout < minutesSinceLastHit;
	};
	
	
	/**
	 * Overrides the `tracker.send` method to send a pageview hit before the
	 * current hit being sent if the session has timed out and the current hit is
	 * not a pageview itself.
	 */
	PageVisibilityTracker.prototype.overrideTrackerSendMethod = function() {
	  this.originalTrackerSendMethod = this.tracker.send;
	
	  this.tracker.send = function() {
	    var args = Array.prototype.slice.call(arguments);
	    var firstArg = args[0];
	    var hitType = isObject(firstArg) ? firstArg.hitType : firstArg;
	    var isPageview = hitType == 'pageview';
	
	    if (!isPageview && this.sessionHasTimedOut()) {
	      var defaultFields = {transport: 'beacon'};
	      this.originalTrackerSendMethod.call(this.tracker, 'pageview',
	          createFieldsObj(defaultFields, this.opts.fieldsObj,
	              this.tracker, this.opts.hitFilter));
	    }
	
	    this.originalTrackerSendMethod.apply(this.tracker, args);
	  }.bind(this);
	};
	
	
	/**
	 * Overrides the tracker's `sendHitTask` to record the time of the previous
	 * hit. This is used to determine whether or not a session has timed out.
	 */
	PageVisibilityTracker.prototype.overrideTrackerSendHitTask = function() {
	  this.originalTrackerSendHitTask = this.tracker.get('sendHitTask');
	  this.lastHitTime = +new Date;
	
	  this.tracker.set('sendHitTask', function(model) {
	    this.originalTrackerSendHitTask(model);
	    this.lastHitTime = +new Date;
	  }.bind(this));
	};
	
	
	/**
	 * Sets the default formatting of the change event label.
	 * This can be overridden by setting the `changeTemplate` option.
	 * @param {string} oldValue The value of the media query prior to the change.
	 * @param {string} newValue The value of the media query after the change.
	 * @return {string} The formatted event label.
	 */
	PageVisibilityTracker.prototype.changeTemplate = function(oldValue, newValue) {
	  return oldValue + ' => ' + newValue;
	};
	
	
	/**
	 * Removes all event listeners and instance properties.
	 */
	 PageVisibilityTracker.prototype.remove = function() {
	  this.tracker.set('sendHitTask', this.originalTrackerSendHitTask);
	  this.tracker.send = this.originalTrackerSendMethod;
	
	  document.removeEventListener(
	      'visibilitychange', this.handleVisibilityStateChange);
	};
	
	
	provide('pageVisibilityTracker', PageVisibilityTracker);


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _preact = __webpack_require__(1);
	
	var _get = __webpack_require__(6);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _story = __webpack_require__(24);
	
	var _story2 = _interopRequireDefault(_story);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RelatedStories = function (_Component) {
	  _inherits(RelatedStories, _Component);
	
	  function RelatedStories() {
	    _classCallCheck(this, RelatedStories);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = {
	      stories: []
	    };
	    return _this;
	  }
	
	  RelatedStories.prototype.loadStories = function loadStories() {
	    var _this2 = this;
	
	    var src = this.props.src || 'https://www.texastribune.org/api/v1/content/?content_type=story,audio,video,pointer&amp;tag=' + this.props.tag + '&amp;tag!=object-tribcast&amp;fields=id,url,readable_pub_date,seo_headline,short_summary,lead_art&amp;limit=4&amp;format=json';
	
	    (0, _get2.default)(src).then(JSON.parse).then(function (_ref) {
	      var results = _ref.results;
	
	      _this2.setState({ stories: results });
	    }).catch(function (err) {
	      throw err;
	    });
	  };
	
	  RelatedStories.prototype.componentDidMount = function componentDidMount() {
	    this.loadStories();
	  };
	
	  RelatedStories.prototype.render = function render() {
	    var stories = this.state.stories;
	    var isColumn = this.props.isColumn;
	    var title = this.props.title;
	
	    var renderedStories = stories.map(function (story) {
	      return (0, _preact.h)(_story2.default, story);
	    });
	
	    return (0, _preact.h)(
	      'div',
	      {
	        'class': 'related-stories' + (isColumn ? ' related-stories--column' : '')
	      },
	      title && (0, _preact.h)(
	        'h3',
	        { 'class': 'section-sub-header' },
	        title
	      ),
	      renderedStories
	    );
	  };
	
	  return RelatedStories;
	}(_preact.Component);
	
	exports.default = RelatedStories;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _preact = __webpack_require__(1);
	
	var Story = function Story(_ref) {
	  var seo_headline = _ref.seo_headline,
	      short_summary = _ref.short_summary,
	      url = _ref.url,
	      lead_art = _ref.lead_art,
	      readable_pub_date = _ref.readable_pub_date;
	
	  return (0, _preact.h)(
	    "article",
	    { "class": "story" },
	    (0, _preact.h)(
	      "a",
	      { "class": "story-link dim", href: url, target: "_blank" },
	      (0, _preact.h)(
	        "div",
	        { "class": "story-media" },
	        (0, _preact.h)(
	          "div",
	          { "class": "story-art" },
	          (0, _preact.h)("img", { src: lead_art.thumbnails.letterbox })
	        ),
	        (0, _preact.h)(
	          "div",
	          { "class": "story-text" },
	          (0, _preact.h)(
	            "header",
	            { "class": "story-header" },
	            (0, _preact.h)(
	              "h4",
	              { "class": "story-headline" },
	              seo_headline
	            ),
	            (0, _preact.h)(
	              "p",
	              { "class": "story-byline" },
	              readable_pub_date
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Story;

/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getMatchingAttributes = __webpack_require__(30);
	
	var _getMatchingAttributes2 = _interopRequireDefault(_getMatchingAttributes);
	
	var _loadScript = __webpack_require__(32);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _objectAssign = __webpack_require__(11);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _selectAll = __webpack_require__(33);
	
	var _selectAll2 = _interopRequireDefault(_selectAll);
	
	var _uniqueId = __webpack_require__(36);
	
	var _uniqueId2 = _interopRequireDefault(_uniqueId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * AdLoader
	 *
	 * @param  {Object} opts
	 * @return {Object}
	 */
	function AdLoader(opts) {
	  var w = window;
	  var hasBeenInit = false;
	  var adSlots;
	
	  var defaultOpts = {
	    attributePrefix: 'dv-gpt-',
	    defaultAdFields: {
	      adUnit: '/5805113/basic',
	      dimensions: [300, 250]
	    },
	    globalMappings: {
	      banner: [[[768, 130], [[728, 90]]]],
	      smallBanner: [[[508, 100], [[468, 60]]]]
	    },
	    gptSrc: 'https://www.googletagservices.com/tag/js/gpt.js',
	    idPrefix: 'dv-gpt-',
	    selector: '.dv-gpt-ad',
	    targetingKey: 'tribpedia',
	    targetingValue: null
	  };
	
	  opts = (0, _objectAssign2.default)({}, defaultOpts, opts);
	
	  var adElements = (0, _selectAll2.default)(opts.selector);
	
	  function setupService() {
	    w.googletag.cmd.push(function () {
	      var pubads = w.googletag.pubads();
	
	      if (opts.targetingKey && opts.targetingValue) {
	        pubads.setTargeting(opts.targetingKey, opts.targetingValue);
	      }
	
	      pubads.enableSingleRequest();
	      w.googletag.enableServices();
	    });
	  }
	
	  function createAds() {
	    adSlots = adElements.map(function (element) {
	      var matchingAttributes = (0, _getMatchingAttributes2.default)(element, opts.attributePrefix);
	      var localOpts = (0, _objectAssign2.default)({}, opts.defaultAdFields, matchingAttributes);
	
	      var adElementId = (0, _uniqueId2.default)(opts.idPrefix);
	      element.setAttribute('id', adElementId);
	
	      var adUnit = w.googletag.defineSlot(localOpts.adUnit, localOpts.dimensions, adElementId);
	
	      if (localOpts.mapping && opts.globalMappings.hasOwnProperty(localOpts.mapping)) {
	        adUnit.defineSizeMapping(opts.globalMappings[localOpts.mapping]);
	      }
	
	      if (localOpts.targetingKey && localOpts.targetingValue) {
	        adUnit.setTargeting(localOpts.targetingKey, localOpts.targetingValue);
	      }
	
	      adUnit.setCollapseEmptyDiv(true);
	      adUnit.addService(w.googletag.pubads());
	
	      w.googletag.display(adElementId);
	
	      return adUnit;
	    });
	  }
	
	  function init() {
	    if (hasBeenInit) return;
	
	    (0, _loadScript2.default)(opts.gptSrc, function () {
	      w.googletag.cmd.push(setupService, createAds);
	
	      hasBeenInit = true;
	    });
	  }
	
	  return {
	    adSlots: adSlots,
	    init: init
	  };
	}
	
	exports.default = AdLoader;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelCase;
	/**
	 * Converts a string from dash or underscore separated to camelCase.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	function camelCase(str) {
	  // remove any dashes or underscores in the string, and grab the following character
	  return str.replace(/[-_]+(\w?)/g, function (match, p1) {
	    // uppercase the following letter
	    return p1.toUpperCase();
	  });
	}

/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getAttributes;
	/**
	 * Gets all the attributes set on an element, and returns them as an Object.
	 *
	 * @param  {Element} element
	 * @return {Object}
	 */
	function getAttributes(element) {
	  var attrs = {};
	
	  // if element is empty, or not ELEMENT_NODE, eject
	  if (!element || element.nodeType !== 1) return attrs;
	
	  // grab all the attributes off the element
	  var map = element.attributes;
	
	  // if there are no attributes, eject
	  if (map.length === 0) return attrs;
	
	  // loop through the attributes and build the object
	  for (var i = 0; i < map.length; i++) {
	    attrs[map[i].name] = map[i].value;
	  }
	
	  return attrs;
	}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getMatchingAttributes;
	
	var _camelCase = __webpack_require__(27);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _getAttributes = __webpack_require__(29);
	
	var _getAttributes2 = _interopRequireDefault(_getAttributes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Searches an element's attributes and returns an Object of all the ones that
	 * begin with a specified prefix. Each matching attribute name is returned
	 * without the prefix, with the remainder converted to camelCase.
	 *
	 * @param  {Element} element
	 * @param  {String} prefix
	 * @return {Object}
	 */
	function getMatchingAttributes(element, prefix) {
	  // get all the attributes on the element
	  var attributes = (0, _getAttributes2.default)(element);
	  var fields = {};
	
	  // loop through the keys of the attributes
	  Object.keys(attributes).forEach(function (key) {
	    // continue if the key begins with supplied prefix
	    if (key.substr(0, prefix.length) === prefix) {
	      // grab the value associated with the original key
	      var value = attributes[key];
	
	      // slice off the prefix and camelCase what is left
	      var field = (0, _camelCase2.default)(key.slice(prefix.length));
	
	      fields[field] = value;
	    }
	  });
	
	  return fields;
	}

/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = loadScript;
	/**
	 * A helper for asynchronously loading scripts.
	 *
	 * Provides a callback interface for passing a function that will only be
	 * called if the script is successfully added to the page.
	 *
	 * @param {String} url The URL for the script to be loaded.
	 * @param {Function} [callback] A function to be called once the script
	 * successfully loads. Not required.
	 * @param {Function} [errorCallback] A function to be called if the script
	 * unsuccessfully loads. Not required.
	 * @returns {void}
	 * @example
	 *
	 * loadScript('backup.js', function () {
	 *   // anything that depends on that script loading
	 * })
	 */
	function loadScript(url, callback, errorCallback) {
	  var script = document.createElement('script');
	  script.src = url;
	
	  if (callback) script.onload = callback;
	  if (errorCallback) script.onerror = errorCallback;
	
	  document.body.appendChild(script);
	}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/* global Node, Window */
	
	/**
	 * Select all matching elements on the page. Uses `document.querySelectorAll`.
	 *
	 * @param {String} el The CSS selector to search for.
	 * @param {Element} [context] The container to search within. Defaults to
	 * `document`.
	 * @returns {Element[]}
	 */
	function selectAll(el, context) {
	  // if `el` is a Node or Window, return it in an Array
	  if (el instanceof Node || el instanceof Window) return [el];
	
	  return Array.prototype.slice.call(typeof el === 'string' ? (context || document).querySelectorAll(el) : el || []);
	}
	
	exports.default = selectAll;

/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(17);
	
	__webpack_require__(18);
	
	__webpack_require__(19);
	
	__webpack_require__(20);
	
	/* global ga */
	
	window.ga = window.ga || function () {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (ga.q = ga.q || []).push(args);
	};
	
	window.ga('require', 'cleanUrlTracker', {
	  indexFilename: 'index.html',
	  queryDimensionIndex: 1,
	  stripQuery: true,
	  trailingSlash: 'add'
	});
	
	window.ga('require', 'eventTracker');
	
	window.ga('require', 'outboundLinkTracker');
	
	// window.ga('require', 'pageVisibilityTracker', {
	//   fieldsObj: {
	//     nonInteraction: null
	//   }
	// });

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = uniqueId;
	// Borrowed from underscore.js: http://underscorejs.org/#uniqueId
	/**
	 * Counter used by {uniqueId} to iterate.
	 * @private
	 * @type {Number}
	 */
	var idCounter = 0;
	
	/**
	 * Generates identifiers unique to a single browser session. Each time it runs,
	 * the integer at the end of the return value will increment.
	 *
	 * @param  {String} [prefix] Optional prefix for identifier
	 * @return {String}
	 * @example
	 *
	 * var identifier = uniqueId();
	 * // returns '1'
	 *
	 * var prefixedIdentifier = uniqueId('label-');
	 * // returns 'label-2'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter + '';
	  return prefix ? prefix + id : id;
	}

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var matches = __webpack_require__(14);
	var parents = __webpack_require__(49);
	
	/**
	 * Gets the closest parent element that matches the passed selector.
	 * @param {Element} element The element whose parents to check.
	 * @param {string} selector The CSS selector to match against.
	 * @param {boolean} shouldCheckSelf True if the selector should test against
	 *     the passed element itself.
	 * @return {?Element} The matching element or undefined.
	 */
	module.exports = function closest(element, selector, shouldCheckSelf) {
	  if (!(element && element.nodeType == 1 && selector)) return;
	
	  var parentElements =
	      (shouldCheckSelf ? [element] : []).concat(parents(element));
	
	  for (var i = 0, parent; parent = parentElements[i]; i++) {
	    if (matches(parent, selector)) return parent;
	  }
	};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	/**
	 * Gets all attributes of an element as a plain JavaScriot object.
	 * @param {Element} element The element whose attributes to get.
	 * @return {Object} An object whose keys are the attribute keys and whose
	 *     values are the attribute values. If no attributes exist, an empty
	 *     object is returned.
	 */
	module.exports = function getAttributes(element) {
	  var attrs = {};
	
	  // Validate input.
	  if (!(element && element.nodeType == 1)) return attrs;
	
	  // Return an empty object if there are no attributes.
	  var map = element.attributes;
	  if (map.length === 0) return {};
	
	  for (var i = 0, attr; attr = map[i]; i++) {
	    attrs[attr.name] = attr.value;
	  }
	  return attrs;
	};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	/**
	 * Returns an array of a DOM element's parent elements.
	 * @param {Element} element The DOM element whose parents to get.
	 * @return {Array} An array of all parent elemets, or an empty array if no
	 *     parent elements are found.
	 */
	module.exports = function parents(element) {
	  var list = [];
	  while (element && element.parentNode && element.parentNode.nodeType == 1) {
	    list.push(element = element.parentNode);
	  }
	  return list;
	};


/***/ })
]);


// WEBPACK FOOTER //
// main.js